import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/job-offer-comparison/OfferComparisonContent.tsx");
